import React, { useEffect, useState,useContext } from 'react';
import { Table, Button, message, Typography, Card, Modal, Descriptions } from 'antd';
import api from '../../api/axios';
import { AuthContext } from '../../context/AuthContext';
const { Text } = Typography;

const CollectCredit = () => {
  const [creditSales, setCreditSales] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSale, setSelectedSale] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
const [messageApi, contextHolder] = message.useMessage();

    const { user } = useContext(AuthContext);
    const userShopId = user?.shopId;
      const userWareId = user?.warehouseId;
  // Fetch credit sales
  const fetchCreditSales = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/api/credit/credit-sales?shopId=${userShopId}`);
        messageApi.success('All credit sales');
        console.log(res.data);
      setCreditSales(res.data);
    } catch (err) {
      console.log(err);
      messageApi.error(err.response?.data?.message || 'Failed to load credit sales');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCreditSales();
  }, []);

  const handleCollect = async (saleId) => {
    try {
      await api.post(`/api/credit/collect/${saleId}`);
      message.success('Credit collected successfully');
      fetchCreditSales();
    } catch (err) {
      message.error(err.response?.data?.message || 'Failed to collect credit');
    }
  };

  const columns = [
    {
      title: 'Ref No',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Customer',
      dataIndex: ['customer', 'name'],
      key: 'customer',
    },
    {
      title: 'Grand Total',
      dataIndex: 'grandTotal',
      key: 'grandTotal',
      render: (val) => `$${val.toFixed(2)}`,
    },
    {
      title: 'Collected',
      dataIndex: 'isCollected',
      key: 'isCollected',
      render: (collected) => (collected ? 'Yes' : 'No'),
    },
    {
      title: 'Collected Date',
      dataIndex: 'collectedDate',
      key: 'collectedDate',
      render: (date) => (date ? new Date(date).toLocaleString() : '-'),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Button
          type="primary"
          disabled
         
        >
          Collect
        </Button>
      ),
    },
  ];

  const handleViewItems = (sale) => {
    setSelectedSale(sale);
    setModalVisible(true);
  };

  return (
    <div style={{ padding: 16 }}>
        {contextHolder}
      <Card title="Credit Sales Collection">
        <Table
          columns={[
            ...columns,
            {
              title: 'Items',
              key: 'items',
              render: (_, record) => (
                <Button onClick={() => handleViewItems(record)}>View Items</Button>
              ),
            },
          ]}
          dataSource={creditSales}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 10 }}
        />
      </Card>

      <Modal
        title={`Sales Items for ${selectedSale?.refNo || ''}`}
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={800}
      >
        {selectedSale && (
          <Table
            dataSource={selectedSale.items}
            rowKey="id"
            pagination={false}
            columns={[
              { title: 'Part Name', dataIndex: ['sparepart', 'partName'], key: 'partName' },
              { title: 'Part Number', dataIndex: ['sparepart', 'partNumber'], key: 'partNumber' },
              { title: 'Unit', dataIndex: 'measurementUnit', key: 'unit' },
              { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
              { title: 'Unit Price', dataIndex: 'unitPrice', key: 'unitPrice', render: (v) => `$${v.toFixed(2)}` },
              { title: 'Line Total', dataIndex: 'lineTotal', key: 'lineTotal', render: (v) => `$${v.toFixed(2)}` },
            ]}
          />
        )}
      </Modal>
    </div>
  );
};

export default CollectCredit;
